// Input felder daten weitergabe
document.addEventListener("DOMContentLoaded", function() {
  // Text-Eingabefelder und Vorschau-Elemente auswählen
  const wunschtextInput = document.querySelector('input[name="properties[Wunschtext]"]');
  const geburtsdatumInput = document.querySelector('input[name="properties[Geburtsdatum]"]');
  const textPreview = document.getElementById("text-preview");
  const textPreview2 = document.getElementById("text-preview-2");
  const textPreview3 = document.getElementById("text-preview-3");

  // Funktion, um den Text der Vorschau zu aktualisieren
  function updateTextPreview() {
    if (textPreview) {
      textPreview.textContent = wunschtextInput.value || "Wunschtext";
    }
    if (textPreview2) {
      textPreview2.textContent = geburtsdatumInput.value || "Geburtsdatum";
    }
    if (textPreview3) {
      textPreview3.textContent = wunschtextInput.value || "Name";
    }
  }

  // Event-Listener für Änderungen an den Eingabefeldern hinzufügen
  if (wunschtextInput) {
    wunschtextInput.addEventListener("input", updateTextPreview);
  }
  if (geburtsdatumInput) {
    geburtsdatumInput.addEventListener("input", updateTextPreview);
  }

  // Initiale Aktualisierung der Vorschau
  updateTextPreview();

});





// Text-Dropdown-Auswahl
document.addEventListener("DOMContentLoaded", function() {
  const btns = document.querySelectorAll('.mw-custom-select__btn');
  const listboxes = document.querySelectorAll('.mw-custom-select__listbox');

  function toggleListbox(event, listbox) {
    event.stopPropagation(); // Verhindert, dass der Klick-Event propagiert wird und das Listbox sofort wieder schließt
    listbox.style.display = (listbox.style.display === 'none' || listbox.style.display === '') ? 'grid' : 'none';
  }

  function hideListbox(event) {
    listboxes.forEach((listbox, index) => {
      const btn = btns[index]; // Verknüpfen des Buttons mit der entsprechenden Listbox
      // Überprüfen, ob das geklickte Element außerhalb der Listbox und des Buttons liegt
      if (!listbox.contains(event.target) && !btn.contains(event.target)) {
        listbox.style.display = 'none';
      }
    });
  }

  function displaySelectedText(radioButton, textStart) {
    if (radioButton.checked) {
      textStart.innerHTML = radioButton.nextElementSibling.innerHTML;
    }
  }

  function updateActiveClass(radioButton) {
    // Entfernen der 'active'-Klasse von allen .mw-r_button-Elementen
    document.querySelectorAll('.mw-r_button').forEach(button => {
      button.classList.remove('active');
    });
    // Hinzufügen der 'active'-Klasse zum Eltern-Element des ausgewählten Radio-Buttons
    radioButton.closest('.mw-r_button').classList.add('active');
  }

  btns.forEach((btn, index) => {
    const listbox = listboxes[index];
    const radioButtons = listbox.querySelectorAll('input[type="radio"]');
    const textStart = btn.querySelector('.mw-text-start');

    // Event-Listener für Klick auf den Button (öffnet/schließt die Listbox)
    btn.addEventListener('click', (event) => toggleListbox(event, listbox));

    // Schließen der Listbox bei Klick außerhalb
    document.addEventListener('click', hideListbox);

    radioButtons.forEach(radioButton => {
      radioButton.addEventListener('change', () => {
        displaySelectedText(radioButton, textStart);
        updateActiveClass(radioButton);
      });
      // Initiale Überprüfung, ob der Radio-Button bereits ausgewählt ist
      if (radioButton.checked) {
        updateActiveClass(radioButton);
      }
    });

    // Schließen der Listbox, wenn eine Option ausgewählt wird
    listbox.addEventListener('click', (event) => {
      if (event.target.tagName === 'INPUT') {
        listbox.style.display = 'none';
      }
    });
  });
});



document.addEventListener("DOMContentLoaded", function () {
  // Alle Radio-Buttons für Schriftarten auswählen
  const radioButtons = document.querySelectorAll('input[type="radio"][data-name="schriftart"]');

  // Funktion zur Größenänderung der Schriftart - GEÄNDERT: Verwendet aktuelle Schriftgröße
  function adjustFontSize(fontItem, multiplier) {
    // Aktuelle Schriftgröße aus dem berechneten Style abrufen
    const currentFontSize = parseFloat(window.getComputedStyle(fontItem).fontSize);
    if (!isNaN(currentFontSize)) {
      // Berechne die neue Schriftgröße basierend auf der aktuellen Größe
      fontItem.style.fontSize = `${currentFontSize * multiplier}px`;
    }
  }

  // NEU: Funktion zur Berechnung der ursprünglichen Schriftgröße basierend auf aktueller Größe und Multiplier
  function calculateOriginalFontSize(fontItem, currentMultiplier) {
    const currentFontSize = parseFloat(window.getComputedStyle(fontItem).fontSize);
    if (!isNaN(currentFontSize) && currentMultiplier !== 0) {
      return currentFontSize / currentMultiplier;
    }
    return currentFontSize;
  }

  // Funktion zur Klasse basierend auf data-value für ein gegebenes Element hinzufügen/entfernen
  function updateClass(element, selectedValue, radioButtons, currentRadioButton) {
    if (element) {
      element.classList.add(selectedValue); // Klasse hinzufügen
      radioButtons.forEach(function (radio) {
        if (radio !== currentRadioButton) {
          const otherValue = radio.getAttribute("data-value");
          element.classList.remove(otherValue); // Klasse entfernen
        }
      });
    }
  }

  // Dynamisch gerenderte Elemente auswählen
  const fontItems = document.querySelectorAll(
    ".font_item, #text-preview, #text-preview-2, #text-preview-3"
  );

  // Überprüfen, ob ein Radio-Button bereits ausgewählt ist
  const checkedRadioButton = Array.from(radioButtons).find(radio => radio.checked);
  
  // Wenn ja, die Schriftgröße sofort anwenden
  if (checkedRadioButton) {
    const selectedValue = checkedRadioButton.getAttribute("data-value");
    const fontSizeMultiplier = parseFloat(checkedRadioButton.getAttribute("font-size"));
    
    if (!isNaN(fontSizeMultiplier)) {
      fontItems.forEach(function (fontItem) {
        adjustFontSize(fontItem, fontSizeMultiplier);
        updateClass(fontItem, selectedValue, radioButtons, checkedRadioButton);
      });
    }
  }

  // Event-Listener für jeden Radio-Button hinzufügen (für zukünftige Änderungen)
  radioButtons.forEach(function (radioButton) {
    radioButton.addEventListener("change", function () {
      // Den Wert des Radio-Buttons abrufen
      const selectedValue = this.getAttribute("data-value");
      const fontSizeMultiplier = parseFloat(this.getAttribute("font-size"));

      if (!isNaN(fontSizeMultiplier)) {
        // GEÄNDERT: Berechne die ursprüngliche Schriftgröße basierend auf der aktuellen Schriftart
        const currentCheckedRadio = Array.from(radioButtons).find(radio => 
          radio !== this && fontItems[0] && fontItems[0].classList.contains(radio.getAttribute("data-value"))
        );
        
        let currentMultiplier = 1;
        if (currentCheckedRadio) {
          currentMultiplier = parseFloat(currentCheckedRadio.getAttribute("font-size")) || 1;
        }

        // Schriftgröße für jedes Element anpassen
        fontItems.forEach(function (fontItem) {
          // Berechne die "ursprüngliche" Schriftgröße basierend auf der aktuellen Größe
          const originalSize = calculateOriginalFontSize(fontItem, currentMultiplier);
          
          // Setze die neue Schriftgröße basierend auf der ursprünglichen Größe
          fontItem.style.fontSize = `${originalSize * fontSizeMultiplier}px`;
          
          updateClass(fontItem, selectedValue, radioButtons, radioButton);
        });
      }
    });
  });
});